import { providers } from 'ethers'
import WalletConnectProvider from '@walletconnect/web3-provider'
import store from '../store'
// import { A_COMMON_DISCONNECT, A_COMMON_SET_CONNECTED_INFO } from '../store/modules/common/types'
import constant from '../configs/constant'
let _provider = {}
// let isSwitch = false
// const decimalToHex = (d) => {
//   let hex = Number(d).toString(16)
//   hex = `0x${hex}`
//   return hex
// }
export const connect = async (chainId) => {
  try {
    const provider = new WalletConnectProvider({
      rpc: constant.CONFIG_RPC,
      chainId: chainId
    })
    _provider = provider
    await provider.enable()
    const web3Provider = new providers.Web3Provider(provider)
    const signer = await web3Provider.getSigner()
    const address = await signer.getAddress()
    window._provider = provider
    // if (!isSwitch) {
    //   store.dispatch(A_COMMON_SET_CONNECTED_INFO, {
    //     key: 'chain',
    //     value: decimalToHex(provider.chainId)
    //   })
    // } else {
    //   isSwitch = true
    // }

    provider.on('disconnect', async () => {
      store.dispatch('disconnect')
    })
    provider.on('connect', async () => {
      console.log('connect')
    })

    provider.on('accountsChanged', (accounts) => {
      if (accounts.length > 0) {
        store.dispatch('setAccount', accounts[0])
        // localStorage.removeItem(U2U_ASTRO_TOKEN)
        // window.location.reload()
      }
    })

    provider.on('chainChanged', (chainId) => {
      console.log(chainId)
      // isSwitch = true
      // store.dispatch(A_COMMON_SET_CONNECTED_INFO, {
      //   key: 'chain',
      //   value: decimalToHex(chainId)
      // })
      // store.dispatch(A_COMMON_CONNECT_WALLET, { type: TYPE_CONNECTS.CONNECT_WALLET })
    })

    return {
      status: true,
      address,
      provider
    }
  } catch (ex) {
    // eslint-disable-next-line no-console
    console.warn(ex)
  }
}

export const disconnect = () => {
  // eslint-disable-next-line no-unused-expressions
  _provider && _provider?.disconnect()
}
